'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  en: {
    event: {
      date: {
        past_event: 'Past event',
        ongoing_event: 'Ongoing event'
      },
      price: {
        free: 'Free'
      },
      timezone: 'Timezone: {{timezone}}'
    },
    workshops: {
      activities: 'Activities',
      speakers: 'Speakers',
      speaker: 'Speaker',
      schedule: 'Schedule',
      selectCategory: 'Choose a category',
      category: 'Category'
    },
    sponsors: {
      companyDescription: 'Company description',
      modalTitle: 'Sponsor information',
      title: 'Sponsors'
    },
    speakers: {
      empty_bio: 'The speaker has no biography.'
    },
    b2b: {
      create_conference_and_participant: 'Please create a conference and a least one participant'
    },
    text: {
      see_less: 'See less',
      read_more: 'Read more',
      less_info: 'Less info',
      more_info: "More info",
      click_here_file: "Click here to view the file",
      no_iframe_src: "Please set the url for the iframe"
    },
    date: {
      available_date: 'Available Dates',
      to: 'to',
      starts_at: 'Starts at',
      ends_at: 'Ends at',
      from_optional: '',
      units: {
        plural: {
          days: 'days',
          hours: 'hours',
          minutes: 'minutes',
          seconds: 'seconds'
        }
      }
    },
    exhibitors: {
      search: 'search',
      reset: 'reset'
    },
    registration: {
      sign_up: 'Sign up',
      type: 'Type',
      price: 'Price',
      register: 'Register',
      info: 'Select your plan and continue on the sign up button by entering your personal details',
      available_seats: 'Availability',
      no_limit: 'No limit',
      attendee_not_found: "We didn't find any record with the provided email.",
      unable_to_modify: "We're sorry the organizer does not allow updates to your registration.",
      general_error: "The mail couldn't be sent. Try again later.",
      continue_registration: "Continue registration",
      already_registered_info: "If you are already registered for this event and want to edit your information, please enter your email address.",
      already_registered_title: "Already registered?",
      mail_sent: "A link to edit your registration information has been sent to your email."
    },
    contact_form: {
      success_message: "The message was sent successfully",
      full_name: 'Full name',
      email: 'Email',
      message: 'Message'
    },
    cookie_consent: {
      privacy_policy: 'Privacy policy',
      explanation: 'This website stores cookies on your computer. These cookies are used to improve your website and provide more personalized services to you, both on this website and through other media.',
      block_information: 'The modal box will be displayed at the bottom of the page'
    },
    map: {
      not_location: "Please assign a location in the event configuration."
    },
    buttons: {
      submit: 'Submit',
      onlyEssential: 'Only essential ones',
      got_it: 'Got it'
    }
  },
  es: {
    event: {
      date: {
        past_event: 'Evento pasado',
        ongoing_event: 'Evento en curso'
      },
      price: {
        free: 'Gratis'
      },
      timezone: 'Zona horaria: {{timezone}}'
    },
    workshops: {
      activities: 'Actividades',
      speakers: 'Ponentes',
      speaker: 'Ponente',
      schedule: 'Programa',
      selectCategory: 'Escoge una categoría',
      category: 'Categoria'
    },
    sponsors: {
      companyDescription: 'Descripción de la compañia',
      modalTitle: 'Información del patrocinador',
      title: 'Patrocinadores'
    },
    speakers: {
      empty_bio: 'El ponente no tiene biografía.'
    },
    b2b: {
      create_conference_and_participant: 'Por favor crea una conferencia y por lo menos un participante'
    },
    text: {
      see_less: 'Ver menos',
      read_more: 'Leer más',
      less_info: 'Menos información',
      more_info: "Más información",
      click_here_file: "Click aquí para ver el archivo",
      no_iframe_src: "Por favor asigna una url para el iframe."
    },
    date: {
      available_date: 'Fechas disponibles',
      to: 'a',
      starts_at: 'Inicia a las',
      ends_at: 'Termina a las',
      from_optional: '',
      units: {
        plural: {
          days: 'días',
          hours: 'horas',
          minutes: 'minutos',
          seconds: 'segundos'
        }
      }
    },
    exhibitors: {
      search: 'buscar',
      reset: 'restablecer'
    },
    registration: {
      sign_up: 'Registrate',
      type: 'Tipo',
      price: 'Precio',
      register: 'Registro',
      info: 'Selecciona tu plan y continúa en el botón de registro ingresando tus datos personales.',
      available_seats: 'Disponibilidad',
      no_limit: 'Sin límite',
      attendee_not_found: "No se encontraron registros con la información ingresada.",
      unable_to_modify: "Lo sentimos, el organizador no permite la modificación de tu registro.",
      general_error: "No se pudo enviar el correo. Inténtalo más tarde.",
      continue_registration: "Continuar inscripción",
      already_registered_info: "Si ya estás registrado en este evento y quieres editar tu información, por favor ingresa tu dirección de correo electrónico",
      already_registered_title: "¿Ya estás registrado?",
      mail_sent: "Te hemos enviado un correo con un enlace para que edites tu información."
    },
    contact_form: {
      success_message: "El mensaje fue enviado con éxito",
      full_name: 'Nombre completo',
      email: 'Email',
      message: 'Mensaje'
    },
    cookie_consent: {
      privacy_policy: 'Política de privacidad',
      explanation: 'Este sitio web almacena cookies en su computador. Estas cookies se utilizan para mejorar el sitio web y brindarle servicios más personalizados, tanto en este sitio web como a través de otros medios.',
      block_information: 'El mensaje informativo se mostrará en la parte inferior de la página'
    },
    map: {
      not_location: "Por favor asigna una ubicación en la configuración del evento."
    },
    buttons: {
      submit: 'Enviar',
      onlyEssential: 'Solo las esenciales.',
      got_it: 'Entendido'
    }
  },
  fr: {
    event: {
      date: {
        past_event: 'Événement passé',
        ongoing_event: 'Événement en cours'
      },
      price: {
        free: 'Gratuit'
      },
      timezone: 'Fuseau horaire : {{timezone}}'
    },
    workshops: {
      activities: 'Activités',
      speakers: 'Intervenants',
      speaker: 'Intervenant',
      schedule: 'Calendrier',
      selectCategory: 'Sélectionner une catégorie',
      category: 'Catégorie'
    },
    sponsors: {
      companyDescription: 'Description de l\'entreprise',
      modalTitle: 'Informations sur le sponsor',
      title: 'Sponsors'
    },
    speakers: {
      empty_bio: "L'orateur n'a pas de biographie."
    },
    b2b: {
      create_conference_and_participant: 'Please create a conference and a least one participant'
    },
    text: {
      see_less: 'Voir moins',
      read_more: 'Voir plus',
      less_info: "Moins d'info",
      more_info: "Plus d'infos",
      click_here_file: "Cliquez ici pour voir le fichier",
      no_iframe_src: "Veuillez définir l'url pour l'iframe."
    },
    date: {
      available_date: 'Sélectionner une date',
      to: 'à',
      starts_at: 'Commence à',
      ends_at: 'Se termine à',
      from_optional: '',
      units: {
        plural: {
          days: 'jours',
          hours: 'heures',
          minutes: 'minutes',
          seconds: 'secondes'
        }
      }
    },
    exhibitors: {
      search: 'rechercher',
      reset: 'réinitialiser'
    },
    registration: {
      sign_up: 'Inscrivez-vous',
      type: 'Type',
      price: 'Prix',
      register: 'S\'inscrire',
      info: 'Sélectionnez votre plan et continuez à vous inscrire en saisissant vos données personnelles.',
      available_seats: 'Disponibilité',
      no_limit: 'Aucune limite',
      attendee_not_found: "L'enregistrement n'a pas été trouvé.",
      unable_to_modify: "Nous sommes désolés, l'organisateur ne permet pas la modification de cet enregistrement.",
      general_error: "Le courrier n'a pas pu être envoyé. Réessayez plus tard.",
      continue_registration: "Continuer l'enregistrement",
      already_registered_info: "Si vous êtes déjà inscrit à cet événement et que vous souhaitez modifier vos informations, veuillez entrer votre adresse e-mail.",
      already_registered_title: "Déjà inscrit?",
      mail_sent: "Un lien pour modifier vos informations d'inscription a été envoyé à votre adresse e-mail."
    },
    contact_form: {
      success_message: "Le message a été envoyé avec succès",
      full_name: 'Nom complet',
      email: 'Email',
      message: 'Message'
    },
    cookie_consent: {
      privacy_policy: 'Politique de confidentialité',
      explanation: "Ce site web stocke des cookies sur votre ordinateur. Ces cookies sont utilisés pour améliorer le site  et vous fournir des services plus personnalisés, à la fois sur ce site et par le biais d'autres médias.",
      block_information: "La boîte modale s'affichera en bas de la page."
    },
    map: {
      not_location: "Veuillez indiquer un lieu dans la configuration de l'événement."
    },
    buttons: {
      submit: 'Soumettre',
      onlyEssential: 'Seulement les essentiels',
      got_it: "J'ai compris"
    }
  },
  de: {
    event: {
      date: {
        past_event: 'Past event',
        ongoing_event: 'Ongoing event'
      },
      price: {
        free: 'Free'
      },
      timezone: 'Zeitzone: {{timezone}}'
    },
    workshops: {
      activities: 'Activities',
      speakers: 'Speakers',
      speaker: 'Speaker',
      schedule: 'Kongressprogramm',
      selectCategory: 'Wählen Sie eine Kategorie',
      category: 'Sektion'
    },
    sponsors: {
      companyDescription: 'Company description',
      modalTitle: 'Sponsor information',
      title: 'Sponsors'
    },
    speakers: {
      empty_bio: 'The speaker has no biography.'
    },
    b2b: {
      create_conference_and_participant: 'Please create a conference and a least one participant'
    },
    text: {
      see_less: 'See less',
      read_more: 'Read more',
      less_info: 'Less info',
      more_info: "More info",
      click_here_file: "Click here to view the file",
      no_iframe_src: "Please set the url for the iframe."
    },
    date: {
      available_date: 'Verfügbare Daten',
      to: 'bis',
      starts_at: 'Beginnt um',
      ends_at: 'Endet um',
      from_optional: 'von ',
      units: {
        plural: {
          days: 'Tage',
          hours: 'Stunden',
          minutes: 'Minuten',
          seconds: 'Sekunden'
        }
      }
    },
    exhibitors: {
      search: 'search',
      reset: 'reset'
    },
    registration: {
      sign_up: 'Sign up',
      type: 'Type',
      price: 'Price',
      register: 'Register',
      info: 'Select your plan and continue on the sign up button by entering your personal details',
      available_seats: 'Availability',
      no_limit: '',
      attendee_not_found: "We didn't find any record with the provided email.",
      unable_to_modify: "We're sorry the organizer does not allow updates to your registration.",
      general_error: "The mail couldn't be sent. Try again later.",
      continue_registration: "Continue registration",
      already_registered_info: "If you are already registered for this event and want to edit your information, please enter your email address.",
      already_registered_title: "Already registered?",
      mail_sent: "A link to edit your registration information has been sent to your email."
    },
    contact_form: {
      success_message: "The message was sent successfully",
      full_name: 'Vor- und Familienname',
      email: 'E-Mail',
      message: 'Ihre Nachricht'
    },
    cookie_consent: {
      privacy_policy: 'Privacy policy',
      explanation: 'This website stores cookies on your computer. These cookies are used to improve your website and provide more personalized services to you, both on this website and through other media.',
      block_information: 'The modal box will be displayed at the bottom of the page'
    },
    map: {
      not_location: "Please assign a location in the event configuration."
    },
    buttons: {
      submit: 'absenden',
      onlyEssential: 'Only essential ones',
      got_it: 'Got it'
    }
  }
};